import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../../Services/Basequerywithreauth";

export const arfsmService = createApi({ 
  reducerPath: "arfsmService",
  baseQuery: createBaseQueryWithReauth(),
  endpoints: (builder) => ({
    
    toggleSlotStatus: builder.mutation({
      query: (payload) => ({
        // url: "trip-management/toggle-slot-status",
        method: "POST",
        body: payload,
      }),
    }),
    truckOrders: builder.query({
      query: (params) => ({
        url: "airline-order-view-list?tab_name=All&activity_status=A",
        params,
      }),
    }),
    awbView: builder.query({
      query: (params) => ({
        url: "airline-awb-list",
        params,
      }),
    }),
    stationRuleList: builder.query({
      query: (params) => ({
        url: "rfs-monitor-settings/list",
        params,
      }),
    }),
    awbDetails: builder.query({
      query: (awbNumber) => ({
          url: `awb/${awbNumber}/details`,
          method: 'GET',
      }),
      }),
    getDiscrepancyList: builder.query({
      query: (params) => ({
          url: `discrepancy/get-all-discrepancy`,
          params,
      }),
      }),
  }),
});

export const {

  useToggleSlotStatusMutation,
  useAwbDetailsQuery,
  useLazyAwbDetailsQuery,
  useTruckOrdersQuery,
  useAwbViewQuery,
  useStationRuleListQuery,
  useGetDiscrepancyListQuery

} = arfsmService;
